import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import RTTable from "../../components/Comman/RT/RTTable";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { noInternetMsg } from "../../config/messageconstant";
import { ChallanJson } from "../../DynamicFormsJson/MastersJSON/challan";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
class ChallanView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      dataList: [],
      fieldData: {},
      transferNo: "",
      date: "",
      vehicleId: "",
      driverId: "",
    };
    this.columns = [
      {
        title: "Sr.No.",
        name: "index",
        align: "center",
      },
      {
        title: "Product Name",
        name: "productName",
      },
      {
        title: "UOM",
        name: "stockHolderUom",
        align: "center",
      },
      {
        title: "Challan Qty",
        name: "challanQty",
        align: "right",
      },
      {
        title: "In Qty",
        name: "inQty",
        align: "right",
      },
      {
        title: "Out Qty",
        name: "outQty",
        align: "right",
      },

      {
        title: "Bill Qty",
        name: "billQty",
        align: "right",
      },

      {
        title: "Total",
        name: "totalQty",
        align: "right",
      },

      {
        title: "Difference",
        name: "difference",
        align: "right",
      },
    ];
  }
  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        const response = apiGet({
          url: endpoint.vanStockTransferHeader + "/day-end-details-by-driver-for-challan?challanId=" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (success) {
            if (!data.error) {
              let rowData = data.data;

              this.setState({
                beatNames: rowData.beatNames !== null ? rowData.beatNames + "." : "",
              });

              let dataList = rowData.vanStockTransferDetail.map(
                (dataObj, index) => {
                  return {
                    index: index + 1,
                    productName:
                      dataObj.productName !== null ? dataObj.productName : "",
                    stockHolderUom:
                      dataObj.stockStakeHolderFirmName !== null
                        ? dataObj.stockStakeHolderFirmName
                        : "",
                    primaryQty:
                      dataObj.primaryQty !== null ? dataObj.primaryQty : "",
                    secondaryQty:
                      dataObj.secondaryQty !== null ? dataObj.secondaryQty : "",
                    challanQty:
                      dataObj.secondaryQty !== null ? dataObj.secondaryQty : "",
                    inQty:
                      dataObj.secondaryInQty !== null
                        ? dataObj.secondaryInQty
                        : "",
                    outQty:
                      dataObj.secondaryOutQty !== null
                        ? dataObj.secondaryOutQty
                        : "",
                    billQty:
                      dataObj.secondaryBillQty !== null
                        ? dataObj.secondaryBillQty
                        : "",
                    totalQty:
                      dataObj.grandTotalSecQty !== null
                        ? dataObj.grandTotalSecQty
                        : "",
                    difference:
                      dataObj.secondaryDiffQty !== null
                        ? dataObj.secondaryDiffQty
                        : "",
                  };
                }
              );

              this.setState({
                dataList,
                fieldData: rowData,
                transferNo:
                  rowData.transferNo !== null ? rowData.transferNo : "",
                date: rowData.date !== null ? rowData.date : "",
                vehicleId: rowData.vehicleId !== null ? rowData.vehicleId : "",
                driverId: rowData.driverId !== null ? rowData.driverId : "",

                DataToSet: [
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Transfer No",
                    value:
                      rowData.transferNo !== null ? rowData.transferNo : "-",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Date",
                    value: rowData.date !== null ? rowData.date : "-",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Stock Holder",
                    value:
                      rowData.stockStakeHolderFirmName !== null &&
                        rowData.stockStakeHolderTypePrefix
                        ? rowData.stockStakeHolderFirmName +
                        " (" +
                        rowData.stockStakeHolderTypePrefix +
                        ")"
                        : "-",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Driver Name",
                    value:
                      rowData.driverName !== null ? rowData.driverName : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Vehicle No",
                    value: rowData.vehicleNo !== null ? rowData.vehicleNo : "",
                  },
                  {
                    xs: 12,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    label: "Challan Status",
                    value:
                      rowData.status !== null
                        ? rowData.status == 0
                          ? "Pending"
                          : rowData.status == 1
                            ? "Recieved"
                            : rowData.status == 2
                              ? "Cancelled"
                              : "Settled"
                        : "",
                  },
                  ...(rowData.status == 3
                    ? [
                      {
                        xs: 12,
                        sm: 4,
                        md: 4,
                        lg: 4,
                        label: "Settlement Date",
                        value:
                          rowData.settleDate !== null
                            ? rowData.settleDate
                            : "",
                      },
                    ]
                    : []),
                ],
              });

              return { data: rowData, success };
            }
            return { data: {}, success: false };
          }

          return { data: {}, success: false };
        });
        return response;
      }
    } else {
      this.props.showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }
  render() {
    const { dataList, DataToSet } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <LandingScreenHeader
            showTitle={ChallanJson.showTitle}
            screenTitle={ChallanJson.screenTitle}
            showSaveBtnMain={false}
            showAddButton={false}
            showBackButton={true}
            onCancel={() => this.props.navigate(-1)}
          />
          <br />
          <DynamicDetails DataToSet={DataToSet} />
          {this.state.beatNames && (
            <div
              style={{
                display: "flex",
                width: "100%",
                marginBottom: "6px",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "22%",
                  fontWeight: 200,
                  color: "#00bdd8",
                  marginTop: "-18px",
                  marginLeft: "15px",
                }}
              >
                Beat Names :
              </div>

              <div
                style={{
                  width: "170%",
                  whiteSpace: "-12px",
                  color: "#000",
                  marginTop: "-12px",
                  marginRight: "10px",
                }}
              >
                {this.state.beatNames || "-"}
              </div>
            </div>
          )}
          <RTTable
            columns={this.columns}
            tableData={dataList}
            isActionColActive={false}
            showPegination={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ChallanView);
